import React from 'react'
import { css } from '@emotion/core'
import * as IPopup from './popup-type'
import { Link } from 'react-router-dom'

export class EmptyRoomPopup extends React.Component<{}, {}> implements IPopup.PopupType {
  height = 115
  width = 200
  private popupRef: React.RefObject<HTMLDivElement> = React.createRef()

  constructor() {
    super({})
  }

  getHeight(): number {
    if (this.popupRef.current) {
      return this.popupRef.current.clientHeight
    }
    return this.height
  }

  getWidth(): number {
    if (this.popupRef.current) {
      return this.popupRef.current.clientWidth
    }
    return this.width
  }

  Component: React.FC<IPopup.PopupProps> = ({ position, room, t }) => {
    return (
      <div ref={this.popupRef} css={[IPopup.popupStyle, css({ ...position })]}>
        <div css={headerStyle}>
          <p>{room.roomNumber}</p>
          <p>{t('cleaningManager.Vacant')}</p>
        </div>

        <div css={IPopup.bodyStyle}>
          <p className="not-assigned">{t('Not assigned')}</p>
        </div>

        <div css={IPopup.footerStyle}>
          <p className="-disabled">{t('Indicators.ReservationDetails')}</p>
          <Link to={{ pathname: '/room-manager/daily' }}>{t('Indicators.WalkIn')}</Link>
        </div>
      </div>
    )
  }
}

const headerStyle = css(IPopup.headerStyle, {
  background: '#F2F2F2',
  p: {
    color: '#676767',
  },
})
